import {Entity} from '@s-ui/domain'

export default class OrderEntity extends Entity {
  /**
   * @param {Object} data
   * @param {string} data.id
   * @param {Object} data.amount
   * @param {Number} data.amount.value
   * @param {String} data.amount.currency
   * @param {Object} data.tax
   * @param {String} data.tax.type
   * @param {Number} data.tax.percentage
   * @param {Number} data.tax.amount
   * @param {Array.<Object>} data.products
   * @param {String} data.products.name
   * @param {Number} data.products.price
   * */

  static validate({id, amount, invalidOrderErrorFactory}) {
    const {amountLabelValue, value} = amount

    const hasId = Boolean(id)
    const hasAmountLabelValue = Boolean(amountLabelValue)
    const hasValue = Boolean(value)

    if (!hasId || !hasAmountLabelValue || !hasValue) {
      throw invalidOrderErrorFactory()
    }
  }
}
